import React, { SVGProps } from 'react';

const SvgPeople = (props: SVGProps<SVGSVGElement>) => {
	return (
		// <svg
		// 	xmlns='http://www.w3.org/2000/svg'
		// 	height='1em'
		// 	viewBox='0 0 24 24'
		// 	width='1em'
		// 	fill='currentColor'
		// 	className='svg-icon'
		// 	{...props}>
		// 	<path d='M0 0h24v24H0V0z' fill='none' />
		// 	<circle cx={9} cy={8.5} opacity={0.3} r={1.5} />
		// 	<path
		// 		d='M4.34 17h9.32c-.84-.58-2.87-1.25-4.66-1.25s-3.82.67-4.66 1.25z'
		// 		opacity={0.3}
		// 	/>
		// 	<path d='M9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm0 6.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zm11.7-3.19c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z' />
		// </svg>

		<svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none" {...props}>
			<path d="M5.0529 5.34994C5.08516 5.34994 5.11681 5.34629 5.14908 5.34507C5.12321 5.16337 5.10494 4.97954 5.10494 4.79054C5.10494 3.23894 6.01801 1.90404 7.33404 1.28346C6.86381 0.514663 6.01953 0 5.0529 0C3.57556 0 2.37793 1.19763 2.37793 2.67497C2.37793 4.15231 3.57526 5.34994 5.0529 5.34994Z" fill="white" />
			<path d="M8.97141 7.76216C10.6125 7.76216 11.9428 6.43181 11.9428 4.79075C11.9428 3.14968 10.6125 1.81934 8.97141 1.81934C7.33035 1.81934 6 3.14968 6 4.79075C6 6.43181 7.33035 7.76216 8.97141 7.76216Z" fill="white" />
			<path d="M11.5632 7.71973C10.8723 8.33178 9.96624 8.70614 8.97069 8.70614C7.97972 8.70614 7.07761 8.33513 6.38764 7.72855C4.58799 8.7107 3.3584 10.6808 3.3584 12.9528C3.3584 13.3107 3.39036 13.6598 3.44879 13.9998H14.5182C14.5769 13.6601 14.6089 13.3107 14.6089 12.9531C14.6089 10.6741 13.3723 8.69883 11.5632 7.71973Z" fill="white" />
			<path d="M5.83204 7.06225C5.6409 6.7926 5.48112 6.4995 5.36272 6.18541C5.26046 6.19423 5.15698 6.20002 5.05228 6.20002C4.15992 6.20002 3.3479 5.86614 2.72671 5.31982C1.10694 6.20397 0 7.97775 0 10.0233C0 10.3453 0.0289137 10.66 0.0812626 10.9662H2.83932C3.23711 9.27765 4.34314 7.86362 5.83204 7.06225Z" fill="white" />
		</svg>
	);
}

export default SvgPeople;
